import React from 'react';
import { Container, Row, Spinner } from "reactstrap";

const LoadingAuth = () => (
  <div className="text-center">

  <Container fluid className="vh-50 d-flex">
    <Row className="justify-content-center align-self-center w-100 text-center">
      <Spinner color="primary" />
      <h6>Initialisation du système de sécurité</h6>
    </Row>
  </Container>

</div>  
);

export default LoadingAuth;
